// @flow
import type { PropsSchema, BasicProps, JsEnv } from 'projects/easy/public/type'
import * as React from 'react'
import computeData from '../../hoc/computeData'
import $ from 'jquery'
import styles from './IncomeCalculator.scss'

type Props = BasicProps & {
  jsEnv: JsEnv,
  style: { [string]: string },
  totalNumber?: number,
  initlNumber?: number,
  howMoney?: number,
  bgColor?: string,
  skimColor?: string,
  children: React.ChildrenArray<React.Node>
};
type State = {
  ifBool: boolean,
  lineDivLeft: number,
  lineDivOffsetWidth: number
};
@computeData({ includeData: true })
export default class extends React.PureComponent<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      ifBool: false,
      lineDivLeft: 0,
      lineDivOffsetWidth: 0
    }
  }

  static schema: PropsSchema = [
    {
      type: 'style'
    },
    'separator',
    {
      key: 'totalNumber',
      title: '可以邀请总数量',
      type: 'number'
    },
    {
      key: 'initlNumber',
      title: '默认多少人(默认滑块位置)',
      type: 'number'
    },
    {
      key: 'howMoney',
      title: '邀请一个人挣多少钱',
      type: 'number'
    },
    {
      key: 'bgColor',
      title: '背景色色值',
      type: 'text'
    },
    {
      key: 'skimColor',
      title: '滑过的颜色色值',
      type: 'text'
    }
  ];

  start (e: SyntheticEvent<HTMLDivElement>) {
    this.setState({
      ifBool: true
    })
  }
  startMove (e?: SyntheticEvent<HTMLDivElement>, flag: boolean) {
    let { lineDivLeft, lineDivOffsetWidth } = this.state
    let totalNumber = this.props.totalNumber || 300
    let howMoney = this.props.howMoney || 98
    let initlNumber = this.props.initlNumber || 50
    let pageX = 0
    if (flag) {
      // $FlowFixMe
      pageX = e.touches ? e.touches[0].pageX : 0
    } else {
      pageX = lineDivOffsetWidth
    }
    let minDivLeft = flag
      ? pageX - lineDivLeft
      : initlNumber / totalNumber * (pageX - 18)
    if (minDivLeft >= lineDivOffsetWidth - 18) {
      minDivLeft = lineDivOffsetWidth - 18
    }
    if (minDivLeft < 0) {
      minDivLeft = 0
    }
    if (this.refs.minDiv) {
      this.refs.minDiv.style.left = minDivLeft + 'px'
    }
    let howPeople = flag
      ? parseInt(minDivLeft / (lineDivOffsetWidth - 18) * totalNumber)
      : initlNumber
    if (this.refs.money) {
      this.refs.money.innerText = howPeople * howMoney
    }
    if (this.refs.inCome) {
      this.refs.inCome.style.width = howPeople / (totalNumber / 100) + '%'
    }
    if (this.refs.people) {
      this.refs.people.innerText = `${howPeople}人`
    }
  }
  move (e: SyntheticEvent<HTMLDivElement>) {
    let { ifBool } = this.state
    if (ifBool) {
      this.startMove(e, true)
      e.preventDefault()
    }
  }
  end (e: SyntheticEvent<HTMLDivElement>) {
    this.setState({
      ifBool: false
    })
  }

  componentDidMount () {
    this.setState({
      lineDivLeft: $(this.refs.lineDiv).offset().left,
      lineDivOffsetWidth: this.refs.lineDiv.offsetWidth
    })
    setTimeout(() => {
      this.startMove(undefined, false)
    }, 100)
    this.refs.minDiv.addEventListener(
      'touchstart',
      e => {
        this.start(e)
      },
      false
    )
    this.refs.minDiv.addEventListener(
      'touchmove',
      e => {
        this.move(e)
      },
      false
    )
    this.refs.minDiv.addEventListener(
      'touchend',
      e => {
        this.end(e)
      },
      false
    )
  }
  render () {
    const { children, style, jsEnv, bgColor, skimColor } = this.props
    const propsBgColor = jsEnv.getString(bgColor)
    const propsSkimColor = jsEnv.getString(skimColor)
    return (
      <div className={`${styles.this}`} style={style}>
        <div>
          <span className={`${styles.desSize}`}>预计收入</span>
          <span className={`${styles.moneySize}`} ref='money'>
            0
          </span>
          <span className={`${styles.moneyColor}`}>元</span>
          <span className={`${styles.pepColor}`}>成功邀请</span>
          <span className={`${styles.pepColor}`} ref='people'>
            0人
          </span>
        </div>
        <div
          className={`${styles.lineDiv}`}
          ref='lineDiv'
          style={{ background: `${propsBgColor}` }}
        >
          <div
            className={`${styles.inCome}`}
            ref='inCome'
            style={{
              background: `${propsSkimColor}`
            }}
          >
            <div
              ref='minDiv'
              className={`${styles.minDiv}`}
              style={{
                border: `3px solid ${propsSkimColor || '#fe4855'}`
              }}
            />
          </div>
        </div>
        <div />
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/ui/Draw/IncomeCalculator.js